import { format, parseISO, differenceInCalendarDays } from "date-fns";
import { it } from "date-fns/locale";

export const STATI_GARA = {
  da_valutare: "Da valutare",
  in_preparazione: "In preparazione",
  presentata: "Presentata",
  aggiudicata: "Aggiudicata",
  persa: "Persa",
  esclusa: "Esclusa",
};

export const STATI_COMMESSA = {
  non_iniziata: "Non iniziata",
  in_corso: "In corso",
  in_revisione: "In revisione",
  consegnata: "Consegnata",
  chiusa: "Chiusa",
  sospesa: "Sospesa",
};

export const KANBAN_COLS = ["non_iniziata", "in_corso", "in_revisione", "consegnata"];

export const PRIORITA = { bassa: "Bassa", media: "Media", alta: "Alta", urgente: "Urgente" };

export const PAGAMENTO = {
  da_fatturare: "Da fatturare",
  fatturato: "Fatturato",
  incassato: "Incassato",
};

export const MACRO_AREE = {
  privata: "Commesse private",
  consulenza: "Consulenze",
  lavori_pubblici: "Lavori pubblici",
  rilievi: "Rilievi topografici",
};

export const STATI_ATTIVITA = { da_fare: "Da fare", in_corso: "In corso", completata: "Completata" };

export const TIPI_RILIEVO = [
  "Rilievo con drone (fotogrammetrico)",
  "Rilievo GPS/GNSS",
  "Rilievo con stazione totale",
  "Rilievo laser scanner 3D",
  "Rilievo batimetrico",
  "Rilievo aerofotogrammetrico",
  "Tracciamento",
  "Altro",
];

// Tavola Z-1 — D.M. 17 giugno 2016 (categorie delle opere)
export const CATEGORIE_Z1 = [
  { gruppo: "E — Edilizia", voci: [
    ["E.01", "Edifici rurali semplici; edifici industriali/artigianali correnti"],
    ["E.02", "Edifici rurali complessi; edifici industriali/artigianali complessi"],
    ["E.03", "Ostelli, ristoranti, negozi, mercati semplici"],
    ["E.04", "Alberghi, villaggi turistici, centri commerciali"],
    ["E.05", "Autorimesse semplici; edifici provvisori di modesta importanza"],
    ["E.06", "Edilizia residenziale di tipo corrente"],
    ["E.07", "Edilizia residenziale pregiata"],
    ["E.08", "Scuole fino a 24/25 classi, ambulatori, asili nido"],
    ["E.09", "Scuole oltre 24/25 classi, case di cura"],
    ["E.10", "Ospedali, università, centri di ricerca e riabilitazione"],
    ["E.11", "Opere cimiteriali semplici; campi sportivi semplici"],
    ["E.12", "Campi sportivi complessi, palestre e piscine coperte"],
    ["E.13", "Teatri, musei, auditorium, stadi, chiese"],
    ["E.14", "Edifici provvisori a servizio di caserme"],
    ["E.15", "Caserme con corredi tecnici correnti"],
    ["E.16", "Uffici pubblici, tribunali, penitenziari, questure"],
    ["E.17", "Verde e arredo urbano semplice"],
    ["E.18", "Arredamenti, giardini, parchi gioco, piazze"],
    ["E.19", "Parchi urbani, riqualificazione paesaggistica e ambientale"],
    ["E.20", "Manutenzione straordinaria / ristrutturazione edifici esistenti"],
    ["E.21", "Restauro edifici di interesse storico-artistico non vincolati"],
    ["E.22", "Restauro e risanamento conservativo edifici vincolati"],
  ]},
  { gruppo: "S — Strutture", voci: [
    ["S.01", "Strutture in c.a. non soggette ad azioni sismiche"],
    ["S.02", "Strutture in muratura, legno, metallo non soggette a sisma"],
    ["S.03", "Strutture in c.a.; verifiche strutturali; ponteggi > 2 anni"],
    ["S.04", "Strutture in muratura/legno/metallo; ponti; consolidamenti"],
    ["S.05", "Dighe, gallerie, opere sotterranee e subacquee, fondazioni speciali"],
    ["S.06", "Strutture di notevole importanza; modellazioni particolari"],
  ]},
  { gruppo: "IA — Impianti a servizio delle costruzioni", voci: [
    ["IA.01", "Impianti idrico-sanitari, fognature, gas, antincendio"],
    ["IA.02", "Impianti di riscaldamento, climatizzazione, solare termico"],
    ["IA.03", "Impianti elettrici e speciali (edifici correnti)"],
    ["IA.04", "Impianti elettrici e speciali (edifici complessi)"],
  ]},
  { gruppo: "IB — Impianti industriali", voci: [
    ["IB.04", "Depositi e discariche senza trattamento rifiuti"],
    ["IB.05", "Impianti industrie molitorie, alimentari, tessili, legno"],
    ["IB.06", "Impianti industria chimica, siderurgica, meccanica"],
    ["IB.07", "Impianti industriali di particolare complessità"],
    ["IB.08", "Linee e reti di trasmissione energia e telecomunicazioni"],
    ["IB.09", "Centrali idroelettriche, stazioni di trasformazione"],
    ["IB.10", "Impianti termoelettrici, elettrochimica, laboratori"],
    ["IB.11", "Campi fotovoltaici, parchi eolici"],
    ["IB.12", "Micro centrali idroelettriche; termoelettrici complessi"],
  ]},
  { gruppo: "P — Paesaggio, ambiente, foreste", voci: [
    ["P.01", "Sistemazione ecosistemi; restauro paesaggistico"],
    ["P.02", "Opere a verde su piccola o grande scala"],
    ["P.03", "Riqualificazione ambiti naturali, rurali, forestali, urbani"],
    ["P.04", "Utilizzazione di bacini estrattivi"],
    ["P.05", "Assetto e utilizzazione forestale, piste forestali"],
    ["P.06", "Infrastrutture e miglioramento dell'assetto rurale"],
  ]},
  { gruppo: "T — Tecnologia", voci: [
    ["T.01", "Sistemi informativi, data center, dematerializzazione"],
    ["T.02", "Reti locali, videosorveglianza, sistemi wireless"],
    ["T.03", "Elettronica industriale, automazione, robotica"],
  ]},
  { gruppo: "V — Viabilità", voci: [
    ["V.01", "Manutenzione viabilità ordinaria"],
    ["V.02", "Strade e ferrovie ordinarie, piste ciclabili"],
    ["V.03", "Strade e ferrovie complesse, piste aeroportuali, funicolari"],
  ]},
  { gruppo: "D — Dighe e opere idrauliche", voci: [
    ["D.01", "Opere di navigazione interna e portuali"],
    ["D.02", "Bonifiche e irrigazioni a deflusso naturale"],
    ["D.03", "Bonifiche con sollevamento meccanico; derivazioni"],
    ["D.04", "Acquedotti e fognature semplici; metanodotti ordinari"],
    ["D.05", "Acquedotti e fognature con problemi tecnici speciali"],
  ]},
  { gruppo: "U — Urbanistica", voci: [
    ["U.01", "Infrastrutture per filiere agricole e agroalimentari"],
    ["U.02", "Valorizzazione ambiti naturali vegetazionali e faunistici"],
    ["U.03", "Strumenti di pianificazione generale, attuativa e di settore"],
  ]},
];

export const CATEGORIE_GARA = {
  progettazione: "Progettazione",
  direzione_lavori: "Direzione lavori",
  collaudo: "Collaudo",
  csp_cse: "CSP/CSE",
  consulenza: "Consulenza",
  pratiche: "Pratiche",
  altro: "Altro",
};

export const DOC_CHECKLIST = [
  "Domanda di partecipazione",
  "Capacità tecnica",
  "Referenze",
  "Cauzione provvisoria",
  "DGUE",
  "Offerta tecnica",
  "Offerta economica",
];

export const statoGaraColor = {
  da_valutare: "bg-slate-100 text-slate-700 border-slate-200",
  in_preparazione: "bg-blue-100 text-blue-800 border-blue-200",
  presentata: "bg-indigo-100 text-indigo-800 border-indigo-200",
  aggiudicata: "bg-green-100 text-green-800 border-green-200",
  persa: "bg-red-100 text-red-800 border-red-200",
  esclusa: "bg-orange-100 text-orange-800 border-orange-200",
};

export const statoCommessaColor = {
  non_iniziata: "bg-slate-100 text-slate-700 border-slate-200",
  in_corso: "bg-blue-100 text-blue-800 border-blue-200",
  in_revisione: "bg-amber-100 text-amber-800 border-amber-200",
  consegnata: "bg-green-100 text-green-800 border-green-200",
  chiusa: "bg-slate-200 text-slate-600 border-slate-300",
  sospesa: "bg-orange-100 text-orange-800 border-orange-200",
};

export const prioritaColor = {
  bassa: "bg-slate-100 text-slate-700 border-slate-200",
  media: "bg-amber-100 text-amber-700 border-amber-200",
  alta: "bg-red-100 text-red-700 border-red-200",
  urgente: "bg-red-600 text-white border-red-700",
};

export const pagamentoColor = {
  da_fatturare: "bg-yellow-100 text-yellow-800 border-yellow-200",
  fatturato: "bg-blue-100 text-blue-800 border-blue-200",
  incassato: "bg-green-100 text-green-800 border-green-200",
};

export function giorniRimanenti(dateStr) {
  if (!dateStr) return null;
  try {
    return differenceInCalendarDays(parseISO(dateStr), new Date());
  } catch {
    return null;
  }
}

export function deadlineStyle(days) {
  if (days === null || days === undefined) return { badge: "bg-slate-100 text-slate-500 border-slate-200", row: "" };
  if (days < 0) return { badge: "bg-red-600 text-white border-red-700", row: "bg-red-50" };
  if (days <= 7) return { badge: "bg-red-100 text-red-800 border-red-200", row: "bg-red-50/60" };
  if (days <= 15) return { badge: "bg-amber-100 text-amber-800 border-amber-200", row: "bg-amber-50/50" };
  if (days <= 30) return { badge: "bg-yellow-100 text-yellow-800 border-yellow-200", row: "" };
  return { badge: "bg-slate-100 text-slate-600 border-slate-200", row: "" };
}

export function deadlineLabel(days) {
  if (days === null || days === undefined) return "—";
  if (days < 0) return `Ritardo ${-days}g`;
  if (days === 0) return "Oggi";
  if (days === 1) return "Domani";
  return `${days}g`;
}

export const fmtData = (d) => {
  if (!d) return "—";
  try {
    return format(parseISO(d), "dd/MM/yyyy", { locale: it });
  } catch {
    return d;
  }
};

export const fmtDataOra = (d) => {
  if (!d) return "—";
  try {
    return format(parseISO(d), "dd/MM/yyyy HH:mm", { locale: it });
  } catch {
    return d;
  }
};

export const fmtEuro = (n) =>
  n === null || n === undefined
    ? "—"
    : new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(n);

export const nomeDipendente = (d) => (d ? `${d.nome} ${d.cognome}` : "—");
